// START Synapse Discount Code - 20231213
/**
 * Handles the adding of a discount code automatically to a users cart between the start/end dates
 * Developed to work specifically on the Awaken sites and with the ReCharge app on Shopify.
 *
 * @param {string} discountCode - The discount code to apply
 * @param {Date} start - The start date of the discount code
 * @param {Date} end - The end date of the discount code
 * */
class SynDiscountCode {
    constructor(
        discountCode = "",
        start = new Date(),
        end = new Date(),
        opts = {}
    ) {
        this.settings = { ...this.defaultOpts, ...opts };
        this.discountCode = discountCode;
        this.start = this.convertToTimezone(start);
        this.end = this.convertToTimezone(end);
        this.startUTC = this.convertToUTC(this.start);
        this.endUTC = this.convertToUTC(this.end);
        this.hasAppliedDiscount = false;

        this.init();
    }

    get defaultOpts() {
        return {
            timer: true, // default: true, handles if the timer should be started to check if the discount code should be applied   
            timerInterval: 1000, // default: 1 second, handles the interval of checking if the discount is active
            timezone: 'EST' // default: 'EST', handles the setting of the start & end date parameters passed in when constructed. currently only accepts 'EST', 'CST', 'MST', 'PST'
        };
    }
    
    init() {
        this.check(); // initially check if the discount code should be applied
        
        if (this.settings.timer) {
            this.startTimer(); // start the timer to check if the discount code should be applied
        }

       document.addEventListener('rebuy:cart.ready', (event) => { 
         if (this.shouldActivateDiscount()) {
            Rebuy.Cart.setDiscount(this.discountCode); 
         } else {
           Rebuy.Cart.removeDiscount(this.discountCode);
           this.removeDiscount();
         }
       });
    }

    // check is the main function the controls applying/removing the discount code
    check() { 
        // check the cookies to see if the discount code has been applied
        this.hasAppliedDiscount = this.getCookieDiscountCode() === this.discountCode;
        
        if (this.shouldActivateDiscount()) {
            // only apply discount if it hasn't been yet AND if they are purchasing a subsciption product
            if (this.hasSubscriptionProductInCart()) {
              this.applyDiscount();
            } else {
              this.removeDiscount();
            }
            // if it has applied the discount AND they no longer have a subscription product in the cart
            // if ( this.)
        } else {
                // if the discount code has been applied and the start/end dates have passed, remove the discount code
            if (this.hasAppliedDiscount) {
                this.removeDiscount();
            }
        }
    }

    // DO NOT CHANGE THIS FUNCTION
    // EACH BRANDED SITE HAS A DIFFERENT METHOD OF DETECTING SUBSCRIPTION PRODUCTS
    hasSubscriptionProductInCart() {
      const flyoutCart = document.getElementById('rebuy-cart');
      const subscriptionDetectionClass = 'property-key-subscription_id';

      let detectedSubscriptionItemInCart = false;

      if (flyoutCart) {
        let items = flyoutCart.querySelectorAll('.rebuy-cart__flyout-items .rebuy-cart__flyout-item');

        if ( 
          items &&
          items.length > 0
        ) {
          items.forEach(cartItem => {
            let subElement = cartItem.querySelector('.rebuy-cart__flyout-item-subscription')

            if (subElement.querySelector('select')) {
              detectedSubscriptionItemInCart = true;
            }
          })
        }
      }

      if (detectedSubscriptionItemInCart) {
        console.log(`Detected a subscription item in the cart!`)
      } else {
        console.log(`No subscription items in the cart!`)
      }

      return detectedSubscriptionItemInCart;
    }

    startTimer() {
        const interval = setInterval(() => {
            this.check();
        }, this.settings.timerInterval);
    }

    applyDiscount() {
      console.log('adding discount')
        this.setCookieDiscountCode(this.discountCode);

        this.hasAppliedDiscount = true;
    }


    removeDiscount() {
        this.clearCookieDiscountCode(this.discountCode)
        localStorage.removeItem('discount_code');

        this.hasAppliedDiscount = false;
    }

    // converts the date to the timezone specified, default is EST
    // TODO: this should be improved to accept more timezones and a better method for conversion to different timezones. 
    // to add more timezones to this function get the utc offset here - https://en.wikipedia.org/wiki/List_of_UTC_offsets
    convertToTimezone(dateString, tzString = "EST") {
        if ( this.settings.timezone ) tzString = this.settings.timezone;
        
        switch (tzString) {
          case 'EST':
            dateString += '-5';
            break;
            
          case 'CST':
            dateString += '-6';
            break;
            
          case 'MST':
            dateString += '-7';
            break;
          
          case 'PST':
            dateString += '-8';
            break;
          
          default:
            break;
        }
        
        return new Date(dateString);
    }

    // converts the date to UTC time
    convertToUTC(date) {
      let utc = Date.UTC(
            date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate(),
            date.getUTCHours(),
            date.getUTCMinutes(),
            date.getUTCSeconds()
        );
      
      return utc;
    }

    // checks if the current time is between the start/end dates
    shouldActivateDiscount() {
        const now = new Date();
        const nowUTC = this.convertToUTC(now);

        if (nowUTC >= this.startUTC && nowUTC <= this.endUTC) {
            return true;
        } else {
            return false;
        }
    }

    getCookieDiscountCode(key = "discount_code") {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${key}=`);

        if (parts.length === 2) return parts.pop().split(";").shift();
    }

    setCookieDiscountCode(discountCode) {
        document.cookie = `discount_code=${discountCode}; path=/`;
    }

    clearCookieDiscountCode(discountCode) {
        document.cookie = `discount=; path=/`;
        document.cookie = `discount_code=; path=/`;
    }
}

const syndc = new SynDiscountCode(
  'USDC25OFFFIRST3MONTHS2024',
   "January 22, 2024 00:59:59",
    "January 28, 2024 23:59:59",
   {
        timer: true,
        timerInterval: 1000,
        timezone: 'PST'
  }
);
// END Synapse Discount Code - 20231213

// START Synapse Injected Form Honeypot - 20240112
/**
 * Injects a honeypot field into forms that are injected by 3rd-party systems.
 * Developed to work specifically on the Awaken sites and with the Klaviyo forms injections.
 *
 * @param {string} wrapperSelector - the selector where the form will eventually be injected to
 * */
class SynInjectedFormHoneypot {
  constructor(wrapperSelector = "", opts = {}) {
    this.settings = { ...this.defaultOpts, ...opts };
    this.wrapperSelector = wrapperSelector;
    this.wrapperElement = document.querySelector(this.wrapperSelector);
    this.hasSetTrap = false;
    this.formElement;
    this.timerId;

    this.init();
  }

  get defaultOpts() {
    return {
      timer: true,
      timerInterval: 100,
    };
  }

  init() {
      this.check();

      if (this.settings.timer) {
        this.startTimer();
      }
  }

  // check is the main function where the logic is run
  check() {
    // wait for the form to be injected and set the trap
    if (
      this.formExists() && 
      !this.hasSetTrap
    ) {
      this.formElement = this.wrapperElement.querySelector("form");

      this.injectHoneypot();

      this.hasSetTrap = true;
    }

    // once the traps been set, check if the honeypot has been filled
    // disable the submit button if it has
    if (this.hasSetTrap) {
      // clearout the interval checks, form has submitted
      if (!this.formElement.querySelector("button")) clearInterval(this.timerId) // not ideal but only indicator that it submitted so far
      
      if (this.isSpam()) {
        this.formElement.querySelector("button").setAttribute("disabled", "true");
        this.formElement.querySelector("input[type='submit']").setAttribute("disabled", "true");
      } else {     
        this.formElement.querySelector("button").removeAttribute("disabled");
        this.formElement.querySelector("input[type='submit']").removeAttribute("disabled");
      }
    }
  }

  isSpam() {
    return this.formElement.querySelector("#syn_honeypot").value !== "";
  }

  formExists() {
    return this.wrapperElement.querySelector("form") !== null;
  }

  injectHoneypot() {
    const honeypotInput = document.createElement("input");

    honeypotInput.type = "text";
    honeypotInput.name = "syn_honeypot";
    honeypotInput.id = "syn_honeypot";
    honeypotInput.style.display = "none";

    this.formElement.appendChild(honeypotInput);
  }

  startTimer() {
    this.timerId = setInterval(() => {
      this.check();
    }, this.settings.timerInterval);
  }
}

// document.addEventListener("DOMContentLoaded", function() {
//   const synKlaviyoFooterFormHoneypot = new SynInjectedFormHoneypot(".footer-klaviyo-form");
// });
// END Synapse Injected Form Honeypot - 20240112

// BOGO
//   function addItemToCart(variant_id, qty) {
//     data = {
//       "id": variant_id,
//       "quantity": qty,
//     }
//     jQuery.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: data,
//       success: function() { 
//         window.location.href = '/cart'; 
//       }
//   }
// $(document).ready(function (){
//   $(document ).on( "click", "#AddToCart",function(){
//   if ( == 4206326186049){
//      addItemToCart(40656647815233, 1);
//   }
//   });
// });